/* Zoci cart drawer: save the gift message / note as the shopper types (the drawer body is re-rendered by the
   theme after every cart change, so listeners are delegated from document). */
(function () {
  var timer;
  function save(el) {
    var status = document.querySelector('[data-zmc-note-status]');
    fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: el.value })
    }).then(function (r) {
      if (status) status.textContent = r.ok ? 'Saved' : 'Could not save, please try again';
    }).catch(function () {
      if (status) status.textContent = 'Could not save, please try again';
    });
  }
  document.addEventListener('input', function (e) {
    var el = e.target.closest && e.target.closest('[data-zmc-note]');
    if (!el) return;
    var status = document.querySelector('[data-zmc-note-status]');
    if (status) status.textContent = '';
    clearTimeout(timer);
    timer = setTimeout(function () { save(el); }, 600);
  });
})();
